import React from 'react';
import { httpRemoveFromCart } from '../../../Hooks/user/user.post.hooks';
import DeleteIcon from '../../../Visuals/Icons/DeleteIcon.icon';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const DeleteCartItem = ({ courseId, userId }) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ courseId, userId }) => httpRemoveFromCart(courseId, userId),
    onSuccess: () => {
      queryClient.invalidateQueries(['cart']);
    },
    onError: (error) => {
      console.error('Error creating discount:', error);
    },
  });
  const deleteCourseFromCart = () => {
    mutation.mutate({ courseId, userId });
  };
  return (
    <div>
      <DeleteIcon functionName={deleteCourseFromCart} />
    </div>
  );
};
DeleteCartItem.propTypes = {
  courseId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

export default DeleteCartItem;
